import styles from "./showseat.module.css";
import Drawer from "@material-ui/core/Drawer";
import {
	Box,
	Container,
	Grid,
	makeStyles,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Slider,
	withStyles,
	// FormControlLabel,
	Checkbox,
	Hidden,
	useMediaQuery,
	useTheme,
    Divider
} from '@material-ui/core';
import React from "react";

import { useState, useEffect } from "react";
import BusBookingForm from "../../form/BusBookingForm";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

// //implementing sidebar

const useStyles = makeStyles((theme) => ({
	root: {
		'& .MuiChip-sizeSmall': {
			height: 36,
		},
	},
	accodin: {
		'& .MuiAccordionSummary-content': {
			justifyContent: 'space-evenly',
		},
	},
	searhform: {
		// backgroundImage: `url(${Home})`,
		background: 'rgb(34, 118, 227)',
		// height: 272,
		backgroundSize: 'cover',
		backgroundRepeat: 'no-repeat',

		paddingTop: 66,

		[theme.breakpoints.down('xs')]: {
			height: 590,
		},
	},
	radio: {
		'& .MuiTypography-body1': {
			fontSize: 13,
		},
	},
	scroll: {
		'&::-webkit-scrollbar': {
			width: '0.2em',
		},
		'&::-webkit-scrollbar-track': {
			// '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: 'rgba(0,0,0,.1)',
			outline: '1px solid slategrey',
			// borderTopLeftRadius: 5,
			// borderTopRightRadius: 5,
			borderRadius: 5,
		},
	},
}));


export const Showseat = () => {
  //implement siderbar

  const [formDrawerState, setformDrawerState] = React.useState(false);
  const classes = useStyles();
  const history = useHistory();
  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "shift")
    ) {
      return;
    }
    setformDrawerState(open);
  };

  const [selectedSeat, setSelectedSeat] = useState({});
  const [condition, setCondition] = useState(false);
  const [seat, setSeat] = useState();

  const handleChange = (e) => {
    let { name, checked, type } = e.target;
    setSelectedSeat({
      ...selectedSeat,
      [name]: (type = "checkbox" ? checked : ""),
    });
  };
  

  useEffect(() => {
    for (let x in selectedSeat) {
      if (selectedSeat[x] === false) {
        setCondition(false);
        continue;
      } else {
        setCondition(true);
        break;
      }
    }

    const a = [];
    for (let y in selectedSeat) {
      if (selectedSeat[y] == false) {
        continue;
      } else {
        a.push(y);
      }
    }

    setSeat(a);
  }, [selectedSeat]);

  return (
    <>
      <div style={{ marginTop: 40 }}>
      <div className={styles.label}>
                                            <span className={styles.lblmsg}>Click on an Available seat to proceed with your transaction.</span>
                                        </div>
        <div style={{overflowY: 'scroll',height:'250px',width:'90%',scrollbarWidth: 'thin',marginTop:10}} className={classes.scroll}>
        <div style={{ display: "flex",marginTop:20 }}>
          <div>
            <input
              onChange={handleChange}
              name="seat1"
              type="checkbox"
              id="checkbox-id"
              style={{ color: "red" }}
            />{" "}
            <label for="checkbox-id"></label>
          </div>
          <div>
            <input
              onChange={handleChange}
              name="seat2"
              type="checkbox"
              id="checkbox-id1"
            />{" "}
            <label for="checkbox-id1"></label>
          </div>
          <div>
            <input
              onChange={handleChange}
              name="seat3"
              type="checkbox"
              id="checkbox-id2"
            />{" "}
            <label for="checkbox-id2"></label>
          </div>
          <div>
            <input
              onChange={handleChange}
              name="seat4"
              type="checkbox"
              id="checkbox-id3"
            />{" "}
            <label for="checkbox-id3"></label>
          </div>
          <div>
            <input
              onChange={handleChange}
              name="seat5"
              type="checkbox"
              id="checkbox-id4"
            />{" "}
            <label for="checkbox-id4"></label>
          </div>
          <div>
            <input
              onChange={handleChange}
              name="seat6"
              type="checkbox"
              id="checkbox-id5"
            />{" "}
            <label for="checkbox-id5"></label>
          </div>
          <div>
            <input
              onChange={handleChange}
              name="seat7"
              type="checkbox"
              id="checkbox-id6"
            />{" "}
            <label for="checkbox-id6"></label>
          </div>
          <div>
            <input
              onChange={handleChange}
              name="seat8"
              type="checkbox"
              id="checkbox-id7"
            />{" "}
            <label for="checkbox-id7"></label>
          </div>
          <div>
            <input
              onChange={handleChange}
              name="seat9"
              type="checkbox"
              id="checkbox-id8"
            />{" "}
            <label for="checkbox-id8"></label>
          </div>
          <div>
            <input
              onChange={handleChange}
              name="seat10"
              type="checkbox"
              id="checkbox-id9"
            />{" "}
            <label for="checkbox-id9"></label>
          </div>
          <div>
            <input
              onChange={handleChange}
              name="seat11"
              type="checkbox"
              id="checkbox-id10"
            />{" "}
            <label for="checkbox-id10"></label>
          </div>
          <div>
            <input
              onChange={handleChange}
              name="seat12"
              type="checkbox"
              id="checkbox-id11"
            />{" "}
            <label for="checkbox-id11"></label>
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat13"
              type="checkbox"
              id="checkbox-id12"
            />{" "}
            <label for="checkbox-id12"></label>
          </div>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat14"
              type="checkbox"
              id="checkbox-id13"
            />{" "}
            <label for="checkbox-id13"></label>
          </div>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat15"
              type="checkbox"
              id="checkbox-id14"
            />{" "}
            <label for="checkbox-id14"></label>
          </div>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat16"
              type="checkbox"
              id="checkbox-id15"
            />{" "}
            <label for="checkbox-id15"></label>
          </div>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat17"
              type="checkbox"
              id="checkbox-id16"
            />{" "}
            <label for="checkbox-id16"></label>
          </div>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat18"
              type="checkbox"
              id="checkbox-id17"
            />{" "}
            <label for="checkbox-id17"></label>
          </div>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat19"
              type="checkbox"
              id="checkbox-id18"
            />{" "}
            <label for="checkbox-id18"></label>
          </div>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat20"
              type="checkbox"
              id="checkbox-id19"
            />{" "}
            <label for="checkbox-id19"></label>
          </div>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat21"
              type="checkbox"
              id="checkbox-id20"
            />{" "}
            <label for="checkbox-id20"></label>
          </div>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat22"
              type="checkbox"
              id="checkbox-id21"
            />{" "}
            <label for="checkbox-id21"></label>
          </div>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat23"
              type="checkbox"
              id="checkbox-id22"
            />{" "}
            <label for="checkbox-id22"></label>
          </div>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat24"
              type="checkbox"
              id="checkbox-id23"
            />{" "}
            <label for="checkbox-id23"></label>
          </div>
        </div>
        <div>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat25"
              type="checkbox"
              id="checkbox-id24"
            />{" "}
            <label for="checkbox-id24"></label>
          </div>
        </div>
        <div>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat26"
              type="checkbox"
              id="checkbox-id25"
            />{" "}
            <label for="checkbox-id25"></label>
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat27"
              type="checkbox"
              id="checkbox-id37"
            />{" "}
            <label for="checkbox-id37"></label>
          </div>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat28"
              type="checkbox"
              id="checkbox-id26"
            />{" "}
            <label for="checkbox-id26"></label>
          </div>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat29"
              type="checkbox"
              id="checkbox-id27"
            />{" "}
            <label for="checkbox-id27"></label>
          </div>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat30"
              type="checkbox"
              id="checkbox-id28"
            />{" "}
            <label for="checkbox-id28"></label>
          </div>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat31"
              type="checkbox"
              id="checkbox-id29"
            />{" "}
            <label for="checkbox-id29"></label>
          </div>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat32"
              type="checkbox"
              id="checkbox-id30"
            />{" "}
            <label for="checkbox-id30"></label>
          </div>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat33"
              type="checkbox"
              id="checkbox-id31"
            />{" "}
            <label for="checkbox-id31"></label>
          </div>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat34"
              type="checkbox"
              id="checkbox-id32"
            />{" "}
            <label for="checkbox-id32"></label>
          </div>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat35"
              type="checkbox"
              id="checkbox-id33"
            />{" "}
            <label for="checkbox-id33"></label>
          </div>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat36"
              type="checkbox"
              id="checkbox-id34"
            />{" "}
            <label for="checkbox-id34"></label>
          </div>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat37"
              type="checkbox"
              id="checkbox-id35"
            />{" "}
            <label for="checkbox-id35"></label>
          </div>
          <div style={{ paddingTop: "20px" }}>
            <input
              onChange={handleChange}
              name="seat38"
              type="checkbox"
              id="checkbox-id36"
            />{" "}
            <label for="checkbox-id36"></label>
          </div>
        </div>
        </div>
        <div className="seat" style={{ marginTop: 20, display: "flex" }}>
          <h3>Seat No.</h3>
          <div style={{ display: "flex" }}>
            {seat?.length !== 0 ? (
              <div style={{ display: "flex", marginLeft: "5px", marginTop: 5 }}>
                {seat?.map((e) => (
                  <h5 style={{ marginLeft: "10px" }}>{e}</h5>
                ))}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <Box
          onClick={toggleDrawer(true)}
          style={{
            background: "orange",
            padding: "5px",
            width: "50%",
            textAlign: "center",
            color: "white",
            borderRadius: "5px",
            fontSize: "22px",
            cursor:'pointer'
          }}
        >
          <span>PROCCED TO BOOK</span>
        </Box>
        <div>
          <Drawer
            anchor="right"
            open={formDrawerState}
            onClose={toggleDrawer(false)}
          >
            <div style={{ width: "700px" }}>
              <Box textAlign={"center"}>
                <h2>Passenger Details</h2>
              </Box>
              <div style={{ padding: 20,overflowY: 'scroll',height:'550px'}}>
                <Box
                  display="flex"
                  alignItems="center"
                  style={{ marginLeft: 10 }}
                >
                  <i class="fa fa-user" aria-hidden="true"></i>
                  <h4 style={{ marginLeft: 10 }}>Passenger Information</h4>
                </Box>
                <Divider />
                
                  
                  <BusBookingForm/>
              </div>
              <Box display='flex' justifyContent='space-between' style={{padding:20}}>
                <Box>
                    <span style={{fontSize:20}}>Total Amount:  INR 8000</span>
                </Box>
                <Box onClick={()=>history.push('/buspaymentdetails')} style={{background:'rgb(57, 201, 187)',padding:5,color:'white',borderRadius:5,cursor:'pointer'}}>
                    <span>PROCCED TO PAY</span>
                </Box>
              </Box>
            </div>
          </Drawer>
        </div>
      </div>
    </>
  );
};
